export default __webpack_public_path__ + "static/media/Pot2.1525c23f.svg";